import { BasePerimeter } from '@argon/iam/perimeters'
const editable = process.env.VUE_APP_ARGON_EDITABLE_FLOWS ? process.env.VUE_APP_ARGON_EDITABLE_FLOWS === 'true' : true

export default new BasePerimeter({
  purpose: 'flow',
  can: {
    update(flow) {
      return editable && this.hasAction(flow, 'update')
    },
    destroy(flow) {
      return editable && this.hasAction(flow, 'delete')
    },
    list() {
      return editable && this.hasPermission('flow:read')
    },
    create() {
      return editable && this.hasPermission('flow:create')
    },
    manage() {
      return editable && this.hasPermission('flow:manage')
    },
    administrate() {
      return this.isAdmin()
    }
  }
})
